import axiosInstance from "./axiosInstance";

export const getAllSales = () =>
    axiosInstance.get("/Sales/GetAllSales");

export const getAllSalesByAgentId = (agentId) =>
    axiosInstance.get(`/Sales/GetAllSalesByAgentId?agentId=${agentId}`);

export const GetTotalFinalPriceByGroupLast30Days= () =>
    axiosInstance.get("/Sales/GetTotalFinalPriceByGroupLast30Days");

export const createSales = (salesData) =>
    axiosInstance.post("/Sales/CreateSales", salesData);

export const updateSalesByAdmin = (salesData) =>
    axiosInstance.put("/Sales/UpdateSalesByAdmin", salesData);